module.exports = __webpack_public_path__ + "MaterialIcons-Regular.woff?012cf6a10129e2275d79d6adac7f3b02";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/style/icon/MaterialIcons-Regular.woff
// module id = 271
// module chunks = 0